export const SCENARIO_ID_PROP_KEY = 'id';
export const ACTIVE_PLAN_ID = 0;
export const SCENARIO_REPLAN_ACTIVE_ENUM = 'Processing';
export const SCENARIO_REPLAN_REVIEW_ENUM = 'Pending_Review';
export const ROUTE_DATE_FORMAT = 'YYYY-MM-DD';
